export default __webpack_public_path__ + "images/kp-8d10def41b377b1163c50a349b8c4394.svg";